import styled, {css} from 'styled-components'
import {DialogFooter} from '@/components/ui/dialog-atoms/DialogAtoms'

export const StyledCommentsFooter = styled(DialogFooter)(
    ({theme: {spacing}}) => css`
        display: flex;
        justify-content: flex-end;
        gap: ${spacing * 2}px;
    `
)

export const StyledCommentsState = styled.div(
    ({theme: {spacing, palette, typography}}) => css`
        ${typography.textSm};
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: ${spacing * 3}px;
        padding: ${spacing * 8}px ${spacing * 4}px;
        color: ${palette.neutral[500]};
        text-align: center;
    `
)

export const StyledCommentsError = styled.div(
    ({theme: {palette, spacing, typography}}) => css`
        ${typography.textSm};
        display: flex;
        align-items: center;
        gap: ${spacing * 2}px;
        padding: ${spacing * 3}px;
        background: ${palette.danger[50]};
        border: 1px solid ${palette.danger[200]};
        border-radius: 8px;
        color: ${palette.danger[700]};
    `
)

export const StyledCommentsEmpty = styled.div(
    ({theme: {palette, typography, spacing}}) => css`
        ${typography.textSm};
        color: ${palette.neutral[400]};
        font-style: italic;
        padding: ${spacing * 4}px 0;
        text-align: center;
    `
)

export const StyledCommentsList = styled.ul(
    ({theme: {spacing}}) => css`
        list-style: none;
        margin: 0;
        padding: 0;
        display: flex;
        flex-direction: column;
        gap: ${spacing * 4}px;
    `
)

export const StyledCommentRow = styled.li(
    ({theme: {spacing}}) => css`
        display: flex;
        align-items: flex-start;
        gap: ${spacing * 3}px;
        min-width: 0;
    `
)

export const StyledCommentContent = styled.div(
    ({theme: {spacing}}) => css`
        display: flex;
        flex-direction: column;
        gap: ${spacing}px;
        min-width: 0;
        flex: 1;
    `
)

export const StyledCommentHeader = styled.div(
    ({theme: {spacing}}) => css`
        display: flex;
        align-items: baseline;
        gap: ${spacing * 2}px;
    `
)

export const StyledCommentAuthor = styled.span(
    ({theme: {palette, typography}}) => css`
        ${typography.textSm};
        font-weight: 600;
        color: ${palette.neutral[900]};
    `
)

export const StyledCommentTimestamp = styled.span(
    ({theme: {palette, typography}}) => css`
        ${typography.textXs};
        color: ${palette.neutral[500]};
    `
)
